'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/index.js';
exports.default = Loading;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _polished = require('polished');
var _themes = require('@marmalade/themes');
var _dot = require('./dot');
var _dot2 = _interopRequireDefault(_dot);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var _componentThemes$load = _themes.componentThemes.loading,
  loadingStyle = _componentThemes$load.loadingStyle,
  loadingTheme = _componentThemes$load.loadingTheme;
var loadingWrapperStyles = function loadingWrapperStyles(props) {
  var theme = loadingTheme(props.theme);
  return {
    margin: theme.space_md + ' auto ' + theme.space_lg,
    maxWidth: '500px',
    textAlign: 'center',
    color: theme[loadingStyle('Text_color')],
    lineHeight: props.inline ? 1 : undefined,
    display: props.inline ? 'inline' : undefined
  };
};
var overlayStyles = function overlayStyles(_ref) {
  var overlay = _ref.overlay,
    theme = _ref.theme,
    alternateBackground = _ref.alternateBackground;
  if (overlay) {
    return {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      backgroundColor: (0, _polished.rgba)(alternateBackground || theme.colorWhite, 0.8),
      margin: 0,
      width: '100%',
      maxWidth: 'none'
    };
  }
};
var LoadingWrapper = (0, _glamorous2.default)('div')(loadingWrapperStyles, overlayStyles);
Loading.propTypes = {
  children: _propTypes.node,
  overlay: _propTypes.bool,
  inline: _propTypes.bool,
  dotCount: _propTypes.number,
  alternateBackground: _propTypes.string
};
Loading.defaultProps = {
  children: undefined,
  overlay: false,
  inline: false,
  dotCount: 3,
  alternateBackground: undefined
};
function Loading(_ref2) {
  var children = _ref2.children,
    dotCount = _ref2.dotCount,
    inline = _ref2.inline,
    overlay = _ref2.overlay,
    rest = _objectWithoutProperties(_ref2, ['children', 'dotCount', 'inline', 'overlay']);
  var styles = {
    inline: inline,
    overlay: overlay
  };
  var dots = [];
  for (var i = 0; i < dotCount; i++) {
    dots.push(_react2.default.createElement(_dot2.default, Object.assign({
      position: i
    }, styles, {
      key: i,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 60
      },
      __self: this
    })));
  }
  return _react2.default.createElement(LoadingWrapper, Object.assign({}, styles, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63
    },
    __self: this
  }), dots, children);
}